<template>
    <div class="spinner" :style="style"/>
</template>
<script>
import Colorable from '../../mixins/Colorable';

export default {
    name: 'Spinner',
    mixins: [Colorable],
    computed: {
        style () {
            return {
                borderTopColor: this.color,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.spinner {
    @include square(40px);
    border: 2px solid $grey-lightest;
    border-radius: 50%;
    pointer-events: none;
    animation: spinner 1s linear infinite;
}

@keyframes spinner {
    100% {
        transform: rotate(360deg);
    }
}
</style>
